.wrapper {
    display: inline-flex;
    align-items: flex-start;
    gap: var(--tempest-space-2);
    cursor: pointer;
    user-select: none;
}

.wrapper.disabled {
    cursor: not-allowed;
    opacity: 0.55;
}

.input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
    pointer-events: none;
}

.box {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border: 1.5px solid var(--tempest-border-strong);
    border-radius: var(--tempest-radius-sm);
    background-color: var(--tempest-bg);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: transparent;
    box-shadow: var(--tempest-shadow-xs);
    transition: var(--tempest-transition-color), var(--tempest-transition-shadow);
}

.wrapper:hover:not(.disabled) .input:not(:checked):not(:indeterminate) + .box {
    border-color: var(--tempest-primary);
}

.input:focus-visible + .box {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}

.input:checked + .box {
    background-color: var(--tempest-primary);
    border-color: var(--tempest-primary);
    color: var(--tempest-primary-foreground);
}

.input:indeterminate + .box {
    background-color: var(--tempest-primary);
    border-color: var(--tempest-primary);
    color: var(--tempest-primary-foreground);
}

.labelWrap {
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: var(--tempest-leading-snug);
}

.label {
    font-size: var(--tempest-text-base);
    color: var(--tempest-text);
}

.description {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-snug);
}
